import React, { useEffect, useState } from 'react';
import { IS_CHECKOUT_PAGE } from 'src/scripts/utils/constants';
import FACE_ID from 'src/scripts/utils/faceid-helpers';
import { aloApiAuthFetch } from 'src/scripts/utils/alo-api-fetch';
import CircularProgress from '@material-ui/core/CircularProgress';
import { handleFormEvents } from 'src/scripts/utils/gtm-data-layer';

const FaceIdButton = ({ faceIdReturnUrl }: { faceIdReturnUrl: string | undefined }) => {
  const [faceIdScriptLoaded, setFaceIdScriptLoaded] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleLogin = async () => {
    const startAuthentication = window.SimpleWebAuthnBrowser?.startAuthentication;
    if (!startAuthentication) {
      console.error('SimpleWebAuthnBrowser is not loaded');
      return;
    }

    setLoader(true);
    handleFormEvents('login_start', 'face id');
    try {
      const customerID = FACE_ID.getFaceIdCustomerInfo()?.id || '';

      const res = await aloApiAuthFetch('/v1/faceid/authentication/options', {
        method: 'POST',
        body: JSON.stringify({ id: Number(customerID) }),
      });
      const authOptions = await res.json();
      const { options } = authOptions;
      const authenticationResponse = await startAuthentication(options);
      const response = await aloApiAuthFetch('/v1/faceid/authentication/verify', {
        method: 'POST',
        body: JSON.stringify({
          id: Number(customerID),
          options: authenticationResponse,
          return_url: faceIdReturnUrl + (IS_CHECKOUT_PAGE ? '' : '&auth_event=login&auth_mode=faceid'),
        }),
      });

      const results = await response.json();

      if (results?.url) {
        window.dataLayer.push({
          event: 'login',
          mode: 'face id',
          customer_id: customerID || '',
        });

        window.location.href = results.url;
      } else {
        console.error('Webauth authetication failed for faceid');
        window.dataLayer.push({
          event: 'login_failed',
          mode: 'face id',
          customer_id: customerID || '',
        });
      }
    } catch (error) {
      // ? [REVISIT] This is another reason for us to implement Toasts, they are offer simple and clean way to show errors to the user; https://notistack.com or anything similar
      console.error('Error during webauth authetication:', error);
    }
    setLoader(false);
  };

  useEffect(() => {
    const faceIdPackagePromise = FACE_ID.loadFaceIdScript();
    faceIdPackagePromise.then((didSucced) => {
      if (didSucced) {
        setFaceIdScriptLoaded(true);
      }
    });
  }, []);

  return faceIdScriptLoaded ? (
    <button type="button" className="btn faceid-button" onClick={handleLogin} disabled={loader}>
      {loader ? (
        <CircularProgress size={20} thickness={2.6} style={{ color: 'var(--primary)' }} />
      ) : (
        <span className="alo-face-id-icon"></span>
      )}
    </button>
  ) : null;
};

export default FaceIdButton;
